module.exports = __webpack_public_path__ + "static/media/emojis2_12.a09ddd44.svg";